import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from '@/plugins/colors'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    theme: {
        dark: false,
        default: 'light',
        disable: false,
        themes: {
            light: {
                primary: colors.primary,
                secondary: colors.secondary,
                accent: colors.accent,
                error: colors.error,
                info: colors.info,
                success: colors.success,
                warning: colors.warning,
            },
            dark: {
                primary: colors.primary,
                secondary: colors.secondary,
                accent: colors.accent,
                error: colors.error,
                info: colors.info,
                success: colors.success,
                warning: colors.warning,
            },
        },
    },
})
